/* eslint-disable no-restricted-syntax */
import uuid from 'uuid/v4';
import { cloneDeep, forEach, round, findIndex, filter, each, reject, map, isEmpty, isEqual } from 'lodash';
import { SELECT_GEOGRAPHICS_TAB_OPTIONS, STUDY_CHANGE_INVALID_POPUP_LABELS } from '../components/geoMap/GeoMapConstant';
import { numberWithCommas } from './CommonUtils';
import { GEOMAP_REQUEST_COUNT } from '../actions/urlTypes';

const secondarySortKey = 'g';

// const handleDivideByZero = (num, den) => (num && den ? num / den : 0);

export const SORT_DIRECTION = {
  NONE: 'none',
  ASC: 'asc',
  DESC: 'desc',
};

const stripToNumber = val => Number(val.replace(/[%*, ]/g, ''));

const upperCaseIfString = val =>
  typeof val === 'string' || val instanceof String ? val.toUpperCase() : val;

export const GEOGRAPHICS_GRID_HEADER_LABELS = [
  {
    key: 'g',
    label: 'Geographies',
    text: 'Geographies',
    compute: upperCaseIfString,
  },
  {
    key: 'ts',
    label: 'Target Sample',
    text: 'Target Sample',
    compute: stripToNumber,
  },
  {
    key: 'tw',
    label: 'Target Weighted',
    text: 'Target Weighted',
    compute: stripToNumber,
  },
  {
    key: 'bw',
    label: 'Base Weighted',
    text: 'Base Weighted',
    compute: stripToNumber,
  },
  {
    key: 'h',
    label: 'Horizontal %',
    text: 'Horizontal %',
    compute: undefined,
  },
  {
    key: 'i',
    label: 'Index',
    text: 'Index',
    compute: undefined,
  },
];

export const smartRoundOff = value => {
  if (value < 1) {
    return Math.round(value * 100) / 100;
  }

  if (value < 100) {
    return Math.round(value * 10) / 10;
  }

  return Math.round(value);
};

// const computePercent = (numerator, denominator, roundOff) => {
//   const result = denominator ? (numerator / denominator) * 100 : 0;
//   return roundOff
//     ? Math.round(result * Math.pow(10, roundOff)) / Math.pow(10, roundOff)
//     : Math.round(result);
// };

const customGeoComparator = (
  sortKey,
  secondarySortKey,
  sortOrder,
  primer,
  selectedGeographicsTabIndex,
) => {
  const getCellMetrics = primer
    ? row => primer(row[sortKey])
    : row => row[sortKey];

  const getCellMetricsSecondarySort = row => upperCaseIfString(row[secondarySortKey]);

  const sortOrderNumber = sortOrder === SORT_DIRECTION.ASC ? 1 : -1;
  const secondarySortOrderNumber = -1;

  return (a, b) => {
    let sortedValues;
    const el1 = getCellMetrics(a);
    const el2 = getCellMetrics(b);
    if (sortKey === 'g' && selectedGeographicsTabIndex !== 4) {
      sortedValues = sortOrderNumber * ((el2 > el1) - (el1 > el2));
    } else {
      sortedValues = sortOrderNumber * ((el1 > el2) - (el2 > el1));
      if (sortedValues === 0) {
        const item1 = getCellMetricsSecondarySort(a);
        const item2 = getCellMetricsSecondarySort(b);
        sortedValues = secondarySortOrderNumber * ((item2 > item1) - (item1 > item2));
      }
    }
    return sortedValues;
  };
};

export const sortGeoMapTable = (
  activeGeoMapSortOrder,
  activeGeoMapTable,
  selectedGeographicsTabIndex
  ) => {
  const sortKey = activeGeoMapSortOrder.sortKey;
  const sortOrder = activeGeoMapSortOrder.sortOrder;
  const cellElements = GEOGRAPHICS_GRID_HEADER_LABELS;
  const primer = cellElements.filter(
    cellElement => cellElement.key === sortKey,
  )[0].compute;

  const newRowSubList = activeGeoMapTable;
  const rowList = [
    ...newRowSubList.sort(
    customGeoComparator(sortKey, secondarySortKey, sortOrder, primer, selectedGeographicsTabIndex),
  ),
  ];

  return rowList;
};

export const getSelectedTab = selectedGeographicsTabIndex => {
  const selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
    .value;
  // let selectedTab = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeographicsTabIndex]
  // .value;
  // if (selectedTab === 'county') {
  //   selectedTab = countyCategorySelectedVal;
  // }
  // if (selectedTab === 'zipcode') {
  //   selectedTab = zipcodeCategorySelectedVal;
  // }
  return selectedTab;
};

export const getGeoMapTableInfo = (
  loginResponse,
  activeAccountId,
  geoMapStudy,
  geoWeightTypes,
  geoMapTarget,
  selectedGeographicsTabIndex,
  countyCategorySelectedVal,
  zipcodeCategorySelectedVal,
  geographicsTableApiQueues,
  getGeoghrapicsTableDataFn,
  setGeoghrapicsTableApiCallStatus,
   ) => {
  const selectedTab = getSelectedTab(selectedGeographicsTabIndex,
    countyCategorySelectedVal, zipcodeCategorySelectedVal);
  const allRequests = cloneDeep(geographicsTableApiQueues);
  const allTabApiRequests = [];
  if (allRequests[selectedTab].length > 0) {
    allTabApiRequests.push({ tab: selectedTab, data: allRequests[selectedTab] });
  }
  forEach(allRequests, (val, key) => {
    if (key !== selectedTab && val.length > 0) {
      allTabApiRequests.push({ tab: key, data: allRequests[key] });
    }
  });

  allTabApiRequests.forEach(({ tab, data }) => {
    if (data.length > 0 && geoMapTarget.length > 0) {
      for (let k = 0; k < data.length; k += 1) {
        if (!data[k].apiCalled) {
          data[k].apiCalled = true;
          setGeoghrapicsTableApiCallStatus(data, tab).then(() => {
            getGeoghrapicsTableDataFn(
              loginResponse.data.userId,
              activeAccountId,
              geoMapStudy.pn,
              geoWeightTypes.wt,
              tab,
              data[k].rowExpressionList,
              data[k].rowHeaderList,
              data[k].rowPathIds,
              data[k].rowSpIds,
              data[k].rowIds,
              data[k].apiuuid);
          });
        }
      }
    }
  });
  
};

export const getGeoMappingRequestsData = formattedTableData => {
  /**
   * This method needs some improvements
   */
  const geoRequests = [];
  const reqCount = GEOMAP_REQUEST_COUNT;
  for (let i = 0; i < formattedTableData.length;) {
    const rowExpressionList = [];
    const rowHeaderList = [];
    const rowPathIds = [];
    const rowIds = [];
    const rowSpIds = [];
    let j = i;
    for (j = i; j < i + reqCount; j += 1) {
      if (formattedTableData[j] === undefined) {
        break;
      }
      rowHeaderList.push(formattedTableData[j].g);
      rowExpressionList.push(formattedTableData[j].e);
      rowPathIds.push(formattedTableData[j].pid);
      rowSpIds.push(formattedTableData[j].sp);
      rowIds.push(formattedTableData[j].id);
    }
    geoRequests.push({
      apiuuid: uuid(),
      rowExpressionList,
      rowHeaderList,
      rowPathIds,
      rowSpIds,
      rowIds,
      apiCalled: false,
    });
    i = j;
  }
  return geoRequests;
};

export const setParentChildrenCountMap = listNodes => {
  let childCountsMap = {};
  const extractNodes = listNodes => {
    forEach(listNodes, item => {
      if (item.s) {
        childCountsMap = {
          ...childCountsMap,
          [item.pid]: item.sc,
        };
        extractNodes(item.s);
      }
    });
  };
  extractNodes(listNodes);
  return childCountsMap;
};

export const extractAllNodes = listNodes => {
  const finalResults = [];
  const extract = listNodes => {
    map(listNodes, elem => {
      if (elem.s) {
        finalResults.push(elem);
        extract(elem.s);
      } else {
        finalResults.push(elem);
      }
    });
  };
  extract(listNodes);
  return finalResults;
};

export const removeDuplicates = arrNodes => {
  const draggableNodes = arrNodes.reduce((acc, current) => {
    const x = acc.find(item => item.id === current.id);
    if (!x) {
      return acc.concat([current]);
    }
    return acc;
  }, []);
  return draggableNodes;
};

export const getGeographiesCount = payload => {
  const uniquePayload = removeDuplicates(filter(payload, el => el.f !== undefined));
  return uniquePayload.length;
};

export const addMetaDataToGeoMapTable = geographyData => {
  const totalTargetWt = geographyData && geographyData.length > 0 ?
    geographyData.map(item => item.tw).reduce((prev, next) => prev + next) : 0;
  const totalBaseWt = geographyData && geographyData.length > 0 ?
    geographyData.map(item => item.bw).reduce((prev, next) => prev + next) : 0;
  geographyData.forEach(item => {
    item.i = Number.isNaN(round(100 * (item.tw / totalTargetWt) * (totalBaseWt / item.bw))) ?
     0 : round(100 * (item.tw / totalTargetWt) * (totalBaseWt / item.bw));
    item.ts = numberWithCommas(item.ts);
    item.tw = numberWithCommas(item.tw);
    item.bw = numberWithCommas(item.bw);
    item.h = item.h < 1 ? item.h : round(item.h);
  });
  return geographyData;
};


export const buildRequestsDataOnStudyChange = tableData => {
  const requestData = [];
  for (let i = 0; i < tableData.length; i += 1) {
    const obj = {
      id: tableData[i].id,
      n: tableData[i].g,
    };
    requestData.push(obj);
  }
  return requestData;
};

export const getTableRequestsDataOnStudyChange = tableData => {
  let allTabApiRequests = {};
  const reqData = cloneDeep(tableData);
  forEach(reqData, (val, key) => {
    if (val.length > 0) {
      const geoRequest = buildRequestsDataOnStudyChange(reqData[key]);
      reqData[key] = geoRequest;
    }
  });
  allTabApiRequests = reqData;
  return allTabApiRequests;
};

export const getBaseAndTargetExpListOnStudyChange = (geoMapTarget, geoMapBase) => {
  const expressionList = [];
  if (geoMapTarget.length > 0 && geoMapBase.length === 0) {
    expressionList.push(geoMapTarget[0].keyword);
  }
  if (geoMapBase.length > 0 && geoMapTarget.length === 0) {
    expressionList.push(geoMapBase[0].keyword);
  }
  if (geoMapTarget.length > 0 && geoMapBase.length > 0) {
    const baseAndTargetExp = `(${geoMapBase[0].keyword}) AND (${geoMapTarget[0].keyword})`;
    expressionList.push(geoMapTarget[0].keyword);
    expressionList.push(geoMapBase[0].keyword);
    expressionList.push(baseAndTargetExp);
  }
  return expressionList;
};

export const invalidDataIndex = data => {
  const index = findIndex(data, { invalid: true });
  return index;
};

export const getInvalidPopupLabels = selectedTabVal => {
  const index = findIndex(STUDY_CHANGE_INVALID_POPUP_LABELS, { selectedTab: selectedTabVal });
  const label = STUDY_CHANGE_INVALID_POPUP_LABELS[index].label;
  return label;
};

export const getTabNameForSamplewtApi = (geoMapTarget, geoMapBase) => {
  let tabVal = '';
  if (geoMapTarget.length > 0 && geoMapBase.length === 0) {
    tabVal = 'target';
  }
  if (geoMapBase.length > 0 && geoMapTarget.length === 0) {
    tabVal = 'base';
  }
  if (geoMapBase.length > 0 && geoMapTarget.length > 0) {
    tabVal = 'targetAndBase';
  }
  return tabVal;
};

// building valid and invalid array bases on study change..
export const getStudyChangeValidationData = (data, targetInfo, baseInfo) => {
  const studyChangeInvalidData = [];
  const studyChangeValidData = [];

  for (let i = 0; i < data.length; i+=1) {
   // getting invalid for all 5 tabs..
    if ((data[i].selectedTab !== 'base' && data[i].selectedTab !== 'target')
    && (data[i].data.length !== 0 && data[i].selectedTab !== 'targetAndBase')) {
      studyChangeInvalidData.push({ selectedTab: data[i].selectedTab,
       data: data[i].data });
    } else {
    // invalid for target data
      if (data[i].selectedTab === 'target') {
        if (invalidDataIndex(data[i].data) !== -1) {
          studyChangeInvalidData.push({ name: targetInfo[0].title,
          selectedTab: data[i].selectedTab });
        } else {
          studyChangeValidData.push({ selectedTab: data[i].selectedTab,
          data: data[i].data[0] });
        }
      }
     // invalid for base data..
      if (data[i].selectedTab === 'base') {
        if (invalidDataIndex(data[i].data) !== -1) {
          studyChangeInvalidData.push({ name: baseInfo[0].title,
           selectedTab: data[i].selectedTab });
        } else {
          studyChangeValidData.push({ selectedTab: data[i].selectedTab,
          data: data[i].data[0] });
        }
      }
      // invalid for base and target combination..
      if (data[i].selectedTab === 'targetAndBase' && invalidDataIndex(data[i].data) !== -1) {
        const invalidData = filter(data[i].data, { invalid: true });
        if (invalidData.length === 3 || (invalidData.length === 1 &&
           invalidDataIndex(data[i].data)) === 2) {
          studyChangeInvalidData.push({ name: baseInfo[0].title, selectedTab: 'base' });
          studyChangeInvalidData.push({ name: targetInfo[0].title, selectedTab: 'target' });
        }
        if (invalidData.length === 2) {
          if (invalidDataIndex(data[i].data) === 0) {
            studyChangeInvalidData.push({ name: targetInfo[0].title, selectedTab: 'target' });
            studyChangeValidData.push({ selectedTab: 'base', data: data[i].data[1] });
          }
        }
        if (invalidData.length === 2) {
          if (invalidDataIndex(data[i].data) === 1) {
            studyChangeValidData.push({
              selectedTab: 'target', data: data[i].data[0] });
            studyChangeInvalidData.push({ name: baseInfo[0].title, selectedTab: 'base' });
          }
        }
      }
      // base and target both are valid setting data for base ...
    // setting data for target when base is already added..
      if (data[i].selectedTab === 'targetAndBase' && invalidDataIndex(data[i].data) === -1) {
        studyChangeValidData.push({
          selectedTab: 'target', data: data[i].data[2] });
        studyChangeValidData.push({ selectedTab: 'base', data: data[i].data[1] });
      }
    }
  }
  return { studyChangeValidData, studyChangeInvalidData };
};


// updating grid data bases on new sample and weight...
export const modifiedBaseAndTargetGridData = (data, target, base) => {
  const targetIndex = findIndex(data, { selectedTab: 'target' });
  const baseIndex = findIndex(data, { selectedTab: 'base' });
  let geoMapTargetGridData = cloneDeep(target);
  let geoMapBaseGridData = cloneDeep(base);

  if (targetIndex !== -1) {
    geoMapTargetGridData[0].sample = data[targetIndex].data.intab;
    geoMapTargetGridData[0].weighted = data[targetIndex].data.weighted;
  } else {
    geoMapTargetGridData = [];
  }
  if (baseIndex !== -1) {
    geoMapBaseGridData[0].sample = data[baseIndex].data.intab;
    geoMapBaseGridData[0].weighted = data[baseIndex].data.weighted;
  } else {
    geoMapBaseGridData = [];
  }
  return { geoMapTargetGridData, geoMapBaseGridData };
};

export const getGeoghrapicsData = (activeAccountId, loginResponse,
  geoMapStudy, getGeoTabData) => {
  const geoDataApiArr = [];
  geoDataApiArr.push(getGeoTabData(loginResponse.data.userId, activeAccountId,
    geoMapStudy.pn, 100000,
    SELECT_GEOGRAPHICS_TAB_OPTIONS[SELECT_GEOGRAPHICS_TAB_OPTIONS[0].index].value));
  geoDataApiArr.push(getGeoTabData(loginResponse.data.userId, activeAccountId,
  geoMapStudy.pn, 200000,
  SELECT_GEOGRAPHICS_TAB_OPTIONS[SELECT_GEOGRAPHICS_TAB_OPTIONS[1].index].value));
  geoDataApiArr.push(getGeoTabData(loginResponse.data.userId, activeAccountId,
  geoMapStudy.pn, 300000,
  SELECT_GEOGRAPHICS_TAB_OPTIONS[SELECT_GEOGRAPHICS_TAB_OPTIONS[2].index].value));
  return Promise.all(geoDataApiArr);
};

export const getCountyData = (activeAccountId, loginResponse,
  geoMapStudy, getGeoTabData) => {
  const countyApis = [];
  countyApis.push(getGeoTabData(loginResponse.data.userId, activeAccountId,
  geoMapStudy.pn, 400000, 'countyByMarket'));
  countyApis.push(getGeoTabData(loginResponse.data.userId, activeAccountId,
  geoMapStudy.pn, 500000,
  'countyByState'));
  return Promise.all(countyApis);
};

export const getZipcodeData = (activeAccountId, loginResponse,
  geoMapStudy, getGeoTabData) => {
  const zipcodeApis = [];
  zipcodeApis.push(getGeoTabData(loginResponse.data.userId, activeAccountId,
    geoMapStudy.pn, 600000, 'zipcodeByMarket'));
  zipcodeApis.push(getGeoTabData(loginResponse.data.userId, activeAccountId,
  geoMapStudy.pn, 700000,
  'zipcodeByState'));
  return Promise.all(zipcodeApis);
};


export const hasGeoDataInTable = geographicsTableData => {
  if (geographicsTableData[SELECT_GEOGRAPHICS_TAB_OPTIONS[0].value].length > 0 ||
    geographicsTableData[SELECT_GEOGRAPHICS_TAB_OPTIONS[1].value].length > 0 ||
    geographicsTableData[SELECT_GEOGRAPHICS_TAB_OPTIONS[2].value].length > 0 ||
    geographicsTableData[SELECT_GEOGRAPHICS_TAB_OPTIONS[3].value].length > 0 ||
    geographicsTableData[SELECT_GEOGRAPHICS_TAB_OPTIONS[4].value].length > 0) {
    return true;
  }
  return false;
};

export const resetGeoTableDataWithZeroes = geographicsTableData => {
  const tabNames = ['county', 'censusRegion', 'state', 'market', 'zipcode'];
  const geoTableData = cloneDeep(geographicsTableData);
  const newGeoTableData = {};
  each(tabNames, tabName => {
    if (geoTableData[tabName].length > 0) {
      const selectedTableData = cloneDeep(geoTableData[tabName]);
      const modifiedSelectedTableData = selectedTableData.map(item => {
        const temp = cloneDeep(item);
        temp.ts = 0;
        temp.tw = 0;
        temp.bw = 0;
        temp.h = 0;
        temp.i = 0;
        return temp;
      });
      newGeoTableData[tabName] = modifiedSelectedTableData;
    } else {
      newGeoTableData[tabName] = [];
    }
  });
  return newGeoTableData;
};

export const removeInvalidData = (invalidData, tableData) => {
  forEach(invalidData, item => {
    tableData = reject(tableData, { id: item.id });
  });
  return tableData;
};

export const updateStudyChangeValidTableData = (studyChangeInvalidData,
  geographicsTableData) => {
  const studyChangeValidTableDataArr = [];
  for (let i = 0; i < studyChangeInvalidData.length; i += 1) {
    if ((studyChangeInvalidData[i].selectedTab !== 'target' && studyChangeInvalidData[i].selectedTab !== 'base') &&
   (studyChangeInvalidData[i].selectedTab !== 'targetAndBase')) {
      const selectedTab = studyChangeInvalidData[i].selectedTab;
      const validTabledata = removeInvalidData(studyChangeInvalidData[i].data,
        geographicsTableData[selectedTab]);
      studyChangeValidTableDataArr.push({ selectedTab: studyChangeInvalidData[i].selectedTab,
        data: validTabledata });
    }
  }
  return studyChangeValidTableDataArr;
};

export const getGeographicsTableDataOnStudyChange = (data, selectedTab,
 getGeographicsTableDataOnStudyChangeFn) => {
  const result = getGeographicsTableDataOnStudyChangeFn(data, selectedTab);
  return result;
};

const extractUniqueParentNodes = range => {
  const childCountsMap = new Map();
  forEach(range, el => {
    forEach(el.sp, item => {
      if (childCountsMap.has(item)) {
        childCountsMap.set(item, childCountsMap.get(item) + 1);
      } else {
        childCountsMap.set(item, 1);
      }
    });
  });
  return childCountsMap;
};

export const updateChildrenCounter = (selectedTab, range, increament,
  parentChildCountMap, setParentChildCountMapThunk) => {
  const clonedMap = cloneDeep(parentChildCountMap);
  let countyByMarketMap = cloneDeep(parentChildCountMap.countyByMarket);
  let countyByStateMap = cloneDeep(parentChildCountMap.countyByState);
  let zipcodeByMarketMap = cloneDeep(parentChildCountMap.zipcodeByMarket);
  let zipcodeByStateMap = cloneDeep(parentChildCountMap.zipcodeByState);
  const extractedUniqParents = extractUniqueParentNodes(range);
  if (selectedTab === 'county') {
    for (const item of extractedUniqParents.keys()) {
      if (clonedMap.countyByMarket[item] !== undefined) {
        const currentLenth = clonedMap.countyByMarket[item];
        countyByMarketMap = {
          ...countyByMarketMap,
          [item]: increament ? currentLenth + extractedUniqParents.get(item) :
          currentLenth - extractedUniqParents.get(item),
        };
      } else {
        const currentLenth = clonedMap.countyByState[item];
        countyByStateMap = {
          ...countyByStateMap,
          [item]: increament ? currentLenth + extractedUniqParents.get(item) :
          currentLenth - extractedUniqParents.get(item),
        };
      }
    }
    setParentChildCountMapThunk(countyByMarketMap,
        'countyByMarket');
    setParentChildCountMapThunk(countyByStateMap,
      'countyByState');
  } else {
    for (const item of extractedUniqParents.keys()) {
      if (clonedMap.zipcodeByMarket[item] !== undefined) {
        const currentLenth = clonedMap.zipcodeByMarket[item];
        let updatedLength = increament ? currentLenth + extractedUniqParents.get(item) :
        currentLenth - extractedUniqParents.get(item);
        updatedLength = updatedLength < 0 ? 0 : updatedLength;
        zipcodeByMarketMap = {
          ...zipcodeByMarketMap,
          [item]: updatedLength,
        };
      } else if (item) {
        const grandParentId = item.split('.')[0];
        let grandParentCount = zipcodeByStateMap[grandParentId];
        const currentLenth = clonedMap.zipcodeByState[item];
        let updatedLength = increament ? currentLenth + extractedUniqParents.get(item) :
          currentLenth - extractedUniqParents.get(item);
        updatedLength = updatedLength < 0 ? 0 : updatedLength;
        if (currentLenth === 0) {
          grandParentCount += 1;
        }
        if (updatedLength === 0) {
          grandParentCount -= 1;
        }
        zipcodeByStateMap = {
          ...zipcodeByStateMap,
          [item]: updatedLength,
          [grandParentId]: grandParentCount,
        };
      }
    }
    setParentChildCountMapThunk(zipcodeByMarketMap,
      'zipcodeByMarket');
    setParentChildCountMapThunk(zipcodeByStateMap,
    'zipcodeByState');
  }
};

export const validateCurrentLabelForBaseAndTarget = (updatedSmartSearch, kpisTitle) => {      
  let compareExpArrsFlag = true;
  if (kpisTitle !== undefined) {
    if (updatedSmartSearch.current !== null &&
      updatedSmartSearch.current.state.expressionFormed.length > 0) {
      const currentExp = updatedSmartSearch.current.state.expressionFormed;
      const kpiExpVal = [];
      forEach(kpisTitle, (key, value) => {
        kpiExpVal.push(value);
      });
      const compareExpArrs = currentExp.sort().every((value, index) => {
        return value === kpiExpVal.sort()[index];
      });
      if ((currentExp.length === kpiExpVal.length && compareExpArrs)) {
        compareExpArrsFlag = false;
      }
    }
  }
  return compareExpArrsFlag;
};


export const compareExpArr = (smartSearchExpList, kpiExpList) => {
  let compareExpArrsFlag = false;
  const compareExpArrs = smartSearchExpList.sort().every((value, index) => {
    return value === kpiExpList.sort()[index];
  });
  if ((smartSearchExpList.length === kpiExpList.length && compareExpArrs)) {
    compareExpArrsFlag = true;
  }
  return compareExpArrsFlag;
};


export const hasGeoDataInTab = geographicsData => {
  let hasGeoDataInTabFlag = true;
  forEach(geographicsData, item => {
    if (item.length > 0) {
      hasGeoDataInTabFlag = false;
    }
  });
  return hasGeoDataInTabFlag;
};

export const getRowHeadersAndExpressions = (items, fileType, settings) => {
  if (fileType === 'pptx') {
    return {
      rowHeaderList: items.map(r => r.g),
      rowExpressionList: items.map(r => r.e),
      minIndex: settings.minIndex ? Number(settings.minIndex) : undefined,
      maxIndex: settings.maxIndex ? Number(settings.maxIndex) : undefined,
      indexGroupCount: settings.indexGroupCount,
      excludeMinIndex: settings.excludeMinIndex ? Number(settings.excludeMinIndex) : undefined,
      excludeMaxIndex: settings.excludeMaxIndex ? Number(settings.excludeMaxIndex) : undefined,
      includeIndexLabel: settings.indexLabel,
      includeGeographyLabel: settings.geoLabel,
    }
  }
  return {
    rowHeaderList: items.map(r => r.g),
    rowExpressionList: items.map(r => r.e),
  };
}

export const buildGeoMapExportRequest = (
  fileName,
  fileType,
  study,
  weightType,
  base,
  target,
  geoMapData,
  selectedGeoMapTabIndex,
  originalTitles,
  mapSettings,
  exportAll
) => {
  const req = {
    // zip = true if fileType = csv and more than one geoMapData type loaded
    zip: fileType === 'csv' && Object.values(geoMapData).filter(i => i.length).length > 1,
    exportFormat: fileType,
    selectedGeoType: SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeoMapTabIndex].label,
    title: fileName,
    fileName,
    productNo: study.pn,
    weightType: weightType.wt,
    selectedWeightName: weightType.wn,
    targetHeader: target[0].title,
    targetExpression: target[0].keyword,
    geoRowData: {},
    targetRenamed: !isEmpty(originalTitles.TargetDataGrid) &&
    !isEqual(originalTitles.TargetDataGrid.originalTitle, target[0].originalTitle),
  };

  if (base.length) {
    req.baseHeader = base[0].title;
    req.baseExpression = base[0].keyword;
    req.baseRenamed = !isEmpty(originalTitles.BaseDataGrid) &&
    !isEqual(originalTitles.BaseDataGrid.originalTitle, base[0].originalTitle);
  }
  const county = geoMapData.county;
  const zipcode = geoMapData.zipcode;
  if (!exportAll && fileType === 'pptx') {
    const tabVal = SELECT_GEOGRAPHICS_TAB_OPTIONS[selectedGeoMapTabIndex].value;
    const tabValForApi = tabVal === 'censusRegion' ? 'region' : tabVal  === 'zipcode' ? 'zipCode' :  tabVal
    req.geoRowData[tabValForApi] = getRowHeadersAndExpressions(
      geoMapData[tabVal], fileType, mapSettings[tabVal]
    );
  } else {
    if (county.length && fileType !== 'pptx') {
      req.geoRowData.county = getRowHeadersAndExpressions(county, fileType, mapSettings.county);
    }
  
    if (zipcode.length && fileType !== 'pptx') {
      req.geoRowData.zipCode = getRowHeadersAndExpressions(zipcode, fileType, mapSettings.zipcode);
    }
  
    if (geoMapData.censusRegion.length) {
      req.geoRowData.region = getRowHeadersAndExpressions(geoMapData.censusRegion, fileType, mapSettings.censusRegion);
    }
  
    if (geoMapData.state.length) {
      req.geoRowData.state = getRowHeadersAndExpressions(geoMapData.state, fileType, mapSettings.state);
    }
  
    if (geoMapData.market.length) {
      req.geoRowData.market = getRowHeadersAndExpressions(geoMapData.market, fileType, mapSettings.market);
    }
  }

  return req;
}
